import React from 'react';
import { withRouter } from 'react-router-dom';
import './App.scss';
import AppRoutes from './AppRoutes';
import AppRoutesNotAutorization from './AppRouterNotAutorization';
import HeaderDashboard from './Components/Shared/HeaderDashboard'
import Footer from './Components/Shared/Footer';
import useUser from './Hooks/useUser';

const App = () => {
  const { token } = useUser();

  if(!token){
    return (
      <div className='container-scroller'>
        <div className='full-page-wrapper'>
          <AppRoutesNotAutorization/>
        </div>
      </div>
    )
  }
  else{
    return (  
      <div className="container-scroller">
        <HeaderDashboard/>
        <div className="container-fluid page-body-wrapper">
          <div className="main-panel">
            <div className="content-wrapper">
              <AppRoutes/>
            </div>
            <Footer/>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(App);
